import borders from "../../base/borders";
import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { borderWidth } = borders;
const { text } = colors;
const { size } = typography;

const tableCell = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(10)} ${pxToRem(14)}`,
      fontSize: size.sm,
      color: text.primary,
      lineHeight: 1.35,
      borderBottom: `${borderWidth[1]} solid ${colors.divider}`,
    },
    sizeSmall: {
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
    },
    head: {
      color: text.primary,
      fontWeight: 600,
      fontSize: size.sm,
      padding: `${pxToRem(8)} ${pxToRem(12)}`,
      whiteSpace: "nowrap",
    },
  },
};

export default tableCell;
